import { RangeDatepicker } from 'chakra-dayzed-datepicker';

const propsConfigs = {
    dateNavBtnProps: {
        // colorScheme: 'blue',
        variant: 'outline',
        width: '40px',
        height: '40px',
    },
    dayOfMonthBtnProps: {
        defaultBtnProps: {
            borderColor: 'gray.200',
            height: '40px',
            width: ' 40px',
            // minWidth: '20px',
            fontSize: '14px',
            color: 'gray.900',
            _hover: {
                background: 'gray.400',
            },
        },
        isInRangeBtnProps: {
            color: 'gray.900',
        },
        selectedBtnProps: {
            background: 'brand.100',
            color: 'gray.900',
        },
        todayBtnProps: {
            background: 'brand.100',
        },
    },
    inputProps: {
        height: '40px',
        borderColor: 'gray.200',
        borderRadius: '24px',
        width: '250px',
        fontSize: '14px',
        fontWeight: '400',
        _focus: {
            borderColor: 'gray.200',
            boxShadow: 'none',
        },
        _active: {},
    },
};

type TProps = {
    selectedDates: Date[];
    onDateChange: (date: Date[]) => void;
};

const DatePicker = ({ selectedDates, onDateChange }: TProps) => {
    return (
        <RangeDatepicker
            configs={{
                dateFormat: 'd LLL, yy',
                monthNames: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December',
                ],
                dayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            }}
            selectedDates={selectedDates}
            onDateChange={onDateChange}
            propsConfigs={propsConfigs}
        />
    );
};

export default DatePicker;
